module.exports = __webpack_public_path__ + "img/icon-piggy.56ecfc15.svg";